import {
  Component,
  inject,
  AfterViewInit,
  ViewChild,
  OnInit,
  DestroyRef,
  signal,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { Router, ActivatedRoute } from '@angular/router';

import {
  Building,
  BuildingService,
  FloorCreateModalComponent,
  Floor,
  FloorService,
  QrListComponent,
  BusinessService,
  Business,
} from '../../../index';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ModalAlertComponent } from '@shared/components';
import { FormControl } from '@angular/forms';
import { GenerateMapComponent } from '../../map-job/generate-map/generate-map.component';
import { ToastAlertService, SpinnerService } from '@core/services';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SearchFieldComponent } from '@shared/components/search-field/search-field.component';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';

@Component({
  templateUrl: './floor-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    ToolbarComponent,
    SearchFieldComponent,
    ButtonComponent,
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    MatPaginatorModule,
  ],
})
export class FloorPageComponent implements AfterViewInit, OnInit {
  private alertService = inject(ToastAlertService);
  private _spinner = inject(SpinnerService);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  selected!: any;
  private _router = inject(Router);
  private _activatedRoute = inject(ActivatedRoute);
  private _business = inject(BusinessService);

  private selectedBuildingId = 0;
  private currentBuilding: any = {};
  private currentBusiness?: Business;
  public pageSubTitle = '';

  displayedColumns: string[] = ['name', 'description', 'isParking', 'options'];
  dataSource: any;
  fielInput!: string;
  private dialog = inject(MatDialog);
  private floorService = inject(FloorService);
  private buildingService = inject(BuildingService);
  private destroyRef = inject(DestroyRef);
  combo!: Building[];
  floors!: Floor[];
  position = new FormControl();
  private selectLogosSysAdmin = -1;
  ngAfterViewInit() {}

  businessId = signal<number | any>(null);

  constructor(private route: ActivatedRoute) {
    this.chargeBuildings();
    this.route?.snapshot?.paramMap.get('id');
    const businessData = history.state.businessData;
    this.businessId.set(businessData.business_id);
  }

  chargeBuildings() {
    this.buildingService.getBuildings().subscribe((request: any) => {
      this.combo = request.reply;
    });
  }

  async loadFloors() {
    this._spinner.show();
    await this.floorService
      .getFloorsByBuilding(this.selectedBuildingId)
      .subscribe((request: any) => {
        this.dataSource = new MatTableDataSource<Floor[]>(request.reply);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this._spinner.hide();
      });
  }

  modalAction(action?: Floor) {
    let width: string;
    if (window.innerWidth <= 768) {
      width = '90%';
    } else {
      width = '50%';
    }
    const dialogActionDetail = this.dialog.open(FloorCreateModalComponent, {
      width: width,
      data: {
        currentBuilding: this.currentBuilding,
        action: action,
      },
    });
    dialogActionDetail
      .beforeClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        this.loadFloors();
      });
  }

  async modalDelete(action?: Floor) {
    const dialogDelete = this.dialog.open(ModalAlertComponent, {
      data: action?.name,
      disableClose: true,
    });
    await dialogDelete.afterClosed().subscribe((result: boolean) => {
      console.log(result);
      if (!result) return;

      if (action) {
        this.floorService
          .deleteFloor(action?.floorid)
          .subscribe((response: any) => {
            this.alertService.sucess('Nivel eliminado exitosamente');
            this._spinner.show();
            this.dataSource = {};
            this.ngOnInit();
          });
      }
    });
  }

  modalQR(floor: Floor) {
    floor.logo_id = this.selectLogosSysAdmin;
    this.dialog.open(QrListComponent, {
      width: '65rem',
      height: '35rem',
      maxWidth: 'none',
      panelClass: 'custom-modal',
      data: floor,
    });
  }

  //See map
  modalMap(floor: Floor) {
    floor.businessId = this.businessId();
    floor.logo_id = this.selectLogosSysAdmin;
    let width: string;
    if (window.innerWidth <= 768) {
      width = '95%';
    } else {
      width = '80%';
    }
    const map = this.dialog.open(GenerateMapComponent, {
      width: width,
      height: '80%',
      data: floor,
    });
  }

  sortByBuilding(id: any) {
    if (id.value == -1) {
      this.dataSource = new MatTableDataSource<Floor>(this.floors);
    } else {
      this.loadFloors();
    }
  }

  async ngOnInit() {
    await this._activatedRoute.params.subscribe((parms: any) => {
      this.selectedBuildingId = parms.id;
    });

    if (this.selectedBuildingId != null) {
      await this.buildingService
        .getBuilding(this.selectedBuildingId)
        .subscribe((response: any) => {
          if (response.code === 10000) {
            this.currentBuilding = <Building>response.reply[0];

            this._business
              .getBusinessByID(this.currentBuilding.businessid)
              .subscribe((bResponse: any) => {
                if (bResponse.code === 10000) {
                  this.currentBusiness = <Business>bResponse.reply[0];
                  this.selectLogosSysAdmin = bResponse.reply[0].logo_id;
                  this.pageSubTitle =
                    this.currentBusiness?.name +
                    ' > ' +
                    this.currentBuilding.name;
                } else {
                  this.alertService.error(bResponse.detail);
                }
              });
          } else {
            this.alertService.error(response.detail);
          }
        });
    }

    await this.loadFloors();
  }
}
